export default class PublipostageExportModel {
  constructor(uuid) {
    this.uuid = uuid;
  }

  getUuid() {
    return this.tuuidype;
  }
}
